




import { defineComponent, ref } from '@vue/composition-api';
import rulesEn from '../data/rulesEn';
import RulesComponent from '@/components/Rules/Rules.vue';
import { Rules } from '../types/Rules';

export default defineComponent({
  name: 'Home',
  components: {
    RulesComponent,
  },
  setup(props, context) {
    const rules = ref<Rules>(rulesEn);
    return {
      rules,
    };
  },
});
